import { makeRoutingContext } from '@mint-lib/routing-context';

export const context = makeRoutingContext();
